/* TPC - show WebPlanex's GST fields only on request, and only to shoppers in India. 12 Oct 2026.
 *
 * The fields themselves belong to the WebPlanex "B2B Integration" app embed. This file does NOT
 * create, rename, read or save any field, so whatever WebPlanex saves still reaches its invoice.
 * It only decides whether WebPlanex's fields are visible:
 *   - shoppers whose Shopify country is India get one link, "Need a GST invoice?", that reveals them;
 *   - everyone else never sees them;
 *   - if a GSTIN or company name is already filled in, the fields show open.
 *
 * WebPlanex injects its own markup, so its class names are not ours to rely on. The fields are found
 * by what they are: inputs inside the cart drawer whose name, id, placeholder or label mentions
 * "gst" or "company". A MutationObserver re-applies this after every drawer re-render.
 *
 * SAFETY: anything that is part of the cart itself (line items, subtotal, order note, checkout
 * button) is never hidden. If the fields cannot be isolated from those, this does nothing and the
 * fields simply stay visible, exactly as WebPlanex shows them today.
 */
(function () {
  if (window.tpcGstToggleBound) return;
  window.tpcGstToggleBound = true;

  var OPEN_KEY = 'tpcGstOpen';
  var memChoice = null;   // the shopper's choice this page view; sessionStorage only carries it across pages
  var PROTECTED = '.checkout-buttons, .subtotal, .cart-item, textarea[name="note"], cart-note, [data-merge-list], .cart-item-upsells';

  function drawer() { return document.querySelector('cart-drawer'); }

  function isIndia(d) {
    var c = (d && d.getAttribute('data-tpc-country')) || (window.Shopify && window.Shopify.country) || '';
    return String(c).toUpperCase() === 'IN';
  }

  function textOf(input) {
    var bits = [input.name, input.id, input.placeholder, input.getAttribute('aria-label')];
    if (input.id) {
      var lab = document.querySelector('label[for="' + input.id + '"]');
      if (lab) bits.push(lab.textContent);
    }
    var prev = input.previousElementSibling;
    if (prev && prev.tagName === 'LABEL') bits.push(prev.textContent);
    return bits.join(' ').toLowerCase();
  }

  function findFields(d) {
    var inputs = d.querySelectorAll('input[type="text"], input:not([type])');
    var gst = null, company = null;
    Array.prototype.forEach.call(inputs, function (i) {
      if (i.closest('.tpc-gst-hold') === null && i.closest(PROTECTED)) return;
      var t = textOf(i);
      if (!gst && t.indexOf('gst') !== -1) gst = i;
      else if (!company && t.indexOf('company') !== -1) company = i;
    });
    return gst ? { gst: gst, company: company } : null;
  }

  // Smallest element holding both fields (and their labels) but none of the cart's own parts.
  function containerFor(f) {
    var node = f.gst.parentElement;
    while (node && node !== document.body) {
      if (node.matches && node.matches('cart-drawer, cart-form, .cart-drawer__footer, [data-merge="footer"]')) return null;
      var hasBoth = !f.company || node.contains(f.company);
      if (hasBoth) return node.querySelector(PROTECTED) ? null : node;
      node = node.parentElement;
    }
    return null;
  }

  function apply() {
    var d = drawer();
    if (!d) return;
    var f = findFields(d);
    if (!f) return;
    var box = containerFor(f);
    if (!box) return;                       // cannot isolate safely: leave WebPlanex as it is

    box.classList.add('tpc-gst-hold');

    if (!isIndia(d)) {                      // outside India: never shown
      box.hidden = true;
      var stray = box.previousElementSibling;
      if (stray && stray.classList.contains('tpc-gst-link')) stray.remove();
      return;
    }

    var link = box.previousElementSibling;
    if (!link || !link.classList.contains('tpc-gst-link')) {
      link = document.createElement('button');
      link.type = 'button';
      link.className = 'tpc-gst-link';
      box.parentNode.insertBefore(link, box);
    }

    // The shopper's own choice wins; with no choice yet, filled-in details show open.
    var filled = !!((f.gst.value || '').trim() || (f.company && (f.company.value || '').trim()));
    var choice = memChoice;
    if (choice === null) {
      try { choice = sessionStorage.getItem(OPEN_KEY); } catch (e) { /* storage blocked */ }
    }
    var open = choice === '1' || (choice === null && filled);

    setState(box, link, open);
  }

  // Only touches the DOM when something actually changes. Writing the same text again would itself
  // be a DOM change, wake the observer, and loop forever.
  function setState(box, link, open) {
    if (box.hidden !== !open) box.hidden = !open;
    var exp = open ? 'true' : 'false';
    if (link.getAttribute('aria-expanded') !== exp) link.setAttribute('aria-expanded', exp);
    var label = open ? 'Hide GST details' : 'Need a GST invoice?';
    if (link.textContent !== label) link.textContent = label;
  }

  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest ? e.target.closest('.tpc-gst-link') : null;
    if (!link) return;
    e.preventDefault();
    var box = link.nextElementSibling;
    if (!box || !box.classList.contains('tpc-gst-hold')) return;
    var open = box.hidden;                  // toggling
    memChoice = open ? '1' : '0';
    try { sessionStorage.setItem(OPEN_KEY, memChoice); } catch (err) { /* storage blocked */ }
    setState(box, link, open);
    if (open) {
      var first = box.querySelector('input');
      if (first) first.focus();
    }
  });

  var pending = null;
  function soon() {
    clearTimeout(pending);
    pending = setTimeout(apply, 60);
  }

  function start() {
    var d = drawer();
    if (!d) return;
    apply();
    new MutationObserver(soon).observe(d, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
